import { Loading } from "../components/Loading";

export default function Index() {
  return <Loading />;
}
